$(document).ready(function(){

  const windowWidth = $(window).width(),
        isMobileDevice = windowWidth < 481 ? true : false;

  if (isMobileDevice) {
    //MOBILE ONLY
    //Cancel the scrollTop Event fired by the theme when selected a filter
    const targetNode = $('html')[0];
    const config = { attributes: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes" && mutation.attributeName == "data-scroll-locked") {

          $(window).scrollTop(0); // Cancel scroll top
          $('.view-mode-activated').trigger("click"); // Force selected view mode
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    $('.collection__filters__toggle').click(function(){
      if ($('.header-collection').length){ $('.header-collection').hide(); }
      if (!$('.filters_activated').length){
        $('.collection__inner').addClass("filters_activated");
      }
    });
    $(document).on("click", '.collection__filters__close', function(){
      if ($('.header-collection').length){
        $('.header-collection').show();
        scrollToTargetAdjusted("#CollectionStickyBar", 90);
      }
      $('.filters_activated').removeClass("filters_activated");
    });
    $(".overlay_collection").click(function(){ $('.collection__filters__close').trigger("click"); });

    SetUpViewMode();
  } else {
    // DESKTOP ONLY
    //Close filters at the page page loading
    //Bind default JS function to filters button
    $('.collection__filter__title').click(function(){
      filterClickProcess($(this));
    });

    closeAllOpenedFilter();

    // Load une page ayant plusieurs filtre (ex : black & XXL)
    // On supprimer un filtre (ex : black)
    // Les selecteurs des filtre restants sont ouverts (ex : Le selecteur "taille" est ouvert)

    //Event are reset when a filter is selected we need to rebind them after they are recreated in the DOM
    var filters = $('.collection__filters')[0];
    var configFilterObserver = { attributes: true, childList: true, subtree: true };
    var callback = (mutationList, observer) => {
      for (var mutationFilterObserver of mutationList) {
        if (mutationFilterObserver.type === "childList") {
          $('.collection__filter__title').each(function(){
            //if ($(this).hasClass("is-expanded")){ openFiltersSelector($(this)); }
            closeAllOpenedFilter();
            $(this).off("click");
            $(this).click(function(){ filterClickProcess($(this)); });
          });
        }
      }
    };
    var filterObserver = new MutationObserver(callback);
    filterObserver.observe(filters, configFilterObserver);
  }

  $(document).on('click', '.btn-display-filter-mobile', function(){
    $('.collection__filters__close').trigger("click");
    $('.view-mode-activated').trigger("click");
    /* Debug safari issue on filter mobile */
    // setTimeout(() => {
    //   $('.collection__filter__title.is-expanded').each(function(){
    //     $('.collection__filter').css("display", "block");
    //   });
    // }, 20);
  });
});

function filterClickProcess($target) {
  if(isFilterOpen($target)) {
    $target.removeClass("filter-open");
  } else {
    if($('.filter-open').length){
      $('.filter-open').each(function(){
        console.log("closing opened filters.");
        closeFilterSelector($(this));
      });
    }
    openFiltersSelector($target);
  }
}
function closeAllOpenedFilter() {
  setTimeout(() => {
    $('.collection__filter__title.is-expanded').each(function(){
      closeFilterSelector($(this));
    });
  }, "10");
}
function isFilterOpen($target) {
  return $target.hasClass("filter-open");
}
function closeFilterSelector($target) {
  $target.removeClass("is-expanded filter-open");
  $target.prop("aria-expanded", false);
  $target.next().removeClass("is-expanded");
  $target.next().prop("aria-expanded", false);
}
function openFiltersSelector($target) {
  let width = $target.outerWidth(),
      $filtersList = $target.next();
  $filtersList.css("width", width);
  $target.addClass("filter-open");
}

function scrollToTargetAdjusted(id_target, offset){
  var element = $(id_target)[0],
  　　headerOffset = offset,
    　elementPosition = element.getBoundingClientRect().top,
    　offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
}

function SetUpViewMode() {
  var cname = "collectionDisplayMode",
      cvalue = ".one-column-mode",
      expdays = 360,
      viewMode = getCookie(cname);

  if ($('.one-column-mode').length) {
    $('.one-column-mode').click(function(){
      $(".grid.grid-two-column").removeClass('grid-two-column');
      if( !$(this).hasClass("view-mode-activated") ){
        $('.two-column-mode').removeClass("view-mode-activated");
        $(this).addClass("view-mode-activated");
        cvalue = ".one-column-mode";
        setCookie(cname, cvalue, expdays);
      }
    });
  }
  if ($('.two-column-mode').length) {
    $('.two-column-mode').click(function(){
      if ($('.grid-two-column').length < 1) {
        $(".collection__products .grid").addClass('grid-two-column');
        if( !$(this).hasClass("view-mode-activated") ){
          $('.one-column-mode').removeClass("view-mode-activated");
          $(this).addClass("view-mode-activated");
          cvalue = ".two-column-mode";  
          setCookie(cname, cvalue, expdays);
        }
      }
    });
  }
  if (viewMode !== false) {
    $(viewMode).trigger("click");
  }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let cookies = document.cookie.split(';');
  for(let i = 0; i < cookies.length; i++) {
    let currentCookie = cookies[i];
    while (currentCookie.charAt(0) == ' ') {
      currentCookie = currentCookie.substring(1);
    }
    if (currentCookie.indexOf(name) == 0) {
      return currentCookie.substring(name.length, currentCookie.length);
    }
  }
  return false;
}